<template>
    <div class="cabinet-status">
        <div class="cabinet-status__content">
            <template v-if="returnStatusImage != null">
                <div class="cabinet-status__image" v-bind:class="'cabinet-status__image--'+returnStatusImage"></div>
            </template>
            <div class="cabinet-status__block">
                <div class="cabinet-status__title">
                    <slot name="title"></slot>
                </div>
            </div>
        </div>
        <div class="cabinet-status__description">
            <div class="cabinet-status__description-content">
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "CabinetStatus",
  props: {
  	focus: {},
    statusImage: {
  		default: null
    }
  },
  computed: {
	  returnStatusImage(){
          return this.statusImage;
      }
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.cabinet-status {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;

    width: 100%;
    padding: 19px 18px;
    background: rgba(255,183,0,0.2);
    &__content {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;

        flex: 1;
    }
    &__image {
        display: inline-block;
        width: 40px;
        height: 40px;
        margin-right: 12px;
        &--bell {
            background: url("~@/assets/svg/icons/question_answers/icon_bell_y.svg") center /contain no-repeat;
        }
        &--cache {
            background: url("~@/assets/svg/icons/question_answers/icon_cache_y.svg") center /contain no-repeat;
        }
        &--man_question {
            background: url("~@/assets/svg/icons/question_answers/icon_man_question_y.svg") center /contain no-repeat;
        }
        &--tenge {
            background: url("~@/assets/svg/icons/question_answers/icon_tenge_y.svg") center /contain no-repeat;
        }
        &--repeat{
            background: url("~@/assets/svg/icons/question_answers/icon_repeat_y.svg") center /contain no-repeat;
        }
    }
    &__block {
        display: inline-flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: space-between;
    }
    &__title {
        text-align: left;
        color: #333333;
        font-size: 16px;
        font-family: $RobotoBold;
    }
    &__description {
        flex: 1;
        margin-left: 30px;

        &-content {
            text-align: left;
            color: #333333;
            font-size: 14px;
            font-family: $RobotoRegular;
        }
    }
}
.cabinet__column--width-100 {
    .cabinet-status {
        &__content {

        }
    }
}
.cabinet__column--width-50 {
    .cabinet-status {
        flex-flow: column wrap;
        &__content {
            width: 100%;
        }
        &__description {
            margin: 10px 0 0 0;
        }
    }
}
.cabinet__column--width-33 {
    .cabinet-status {
        flex-flow: column wrap;
        &__content {
            flex-flow: column wrap;
            width: 100%;
        }
        &__image {
            margin: 0 0 10px 0;
        }
        &__title {
            br {
                display: none;
            }
        }
        &__description {
            margin: 10px 0 0 0;
        }
        &__description-content {
            br {
                display: none;
            }
        }
    }
}
</style>
